import { render, staticRenderFns } from "./expediente-persona.vue?vue&type=template&id=24bdde49&scoped=true&"
import script from "./expediente-persona.component.ts?vue&type=script&lang=ts&"
export * from "./expediente-persona.component.ts?vue&type=script&lang=ts&"
import style0 from "./expediente-persona.vue?vue&type=style&index=0&id=24bdde49&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bdde49",
  null
  
)

export default component.exports